// define __esModule on exports
__webpack_require__.r = function(exports) {
	Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	Object.defineProperty(exports, '__esModule', { value: true });
};